import { ParticipantPresenterProps } from 'features/ParticipantItem/types';
import { useSIPParticipant } from 'useCase/SIPTelephony/useSIPParticipant';
import { ViewerVCS } from './ViewerVCS';
import { ViewerSIP } from './ViewerSIP';

interface Props extends ParticipantPresenterProps {}

export const Viewer = (props: Props) => {
    const { checkIsSIPParticipant } = useSIPParticipant();

    const { participant } = props;
    const isSIPParticipant = checkIsSIPParticipant(participant);

    if (isSIPParticipant) {
        return <ViewerSIP {...props} />;
    }

    return <ViewerVCS {...props} />;
};
